import { QueryByType } from "../../../domain/constants/QueryByType";
import { Sell } from '../../../domain/models/Sell';

export class ModalMovState {
    title: string;
    isResume: boolean;
    queryType: QueryByType;
    date: Date;
    dateEnd: Date;
    isCustom: boolean;
    page: number;
    data: Sell[];
    dataAll: Sell[];

    constructor({
        title = "",
        isResume = true,
        queryType = QueryByType.DATE,
        date = new Date(),
        dateEnd = new Date(),
        isCustom = false,
        page = 0,
        data = [],
        dataAll = []
    }: any) {
        this.title = title;
        this.isResume = isResume;
        this.queryType = queryType;
        this.date = date;
        this.dateEnd = dateEnd;
        this.isCustom = isCustom;
        this.page = page;
        this.data = data;
        this.dataAll = dataAll;
    }
}